import { faInfoCircle, faSearch } from '@fortawesome/fontawesome-free-solid'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { Fragment, useCallback, useContext, useEffect, useRef, useState } from 'react'
import "slick-carousel/slick/slick-theme.css"
import "slick-carousel/slick/slick.css"

import { AppData } from '../../../src/data/index'
import { Block, Flex, Grid, H2, H5, ImageBlock, Input, P, Product, Select, SelectImg } from '../../components/basic'
import { LABELS, MESSAGES, TITLES, CURRENCY } from '../../constants'
import { specialCaseSelectionList } from '../../constants/appconstants'
import { Blue, Gray_600, Gray_Dark } from '../../constants/colors'
import { setChoices, setPopup, setStep, setSubStep } from '../../context/actions'
import { GAContext } from '../../context/googleAnalytics'
import { isMobile, sortByOrder } from '../../utils'
import { PatchesSlider, Popup, SelectWithCustomSizingOption } from './components'
import { 
    DISPLAY_TYPES, 
    LEFT_SLEAVE_DROPDOWN_VALUES, 
    NO_THANKS_OPTION, 
    RIGHT_SLEAVE_DROPDOWN_VALUES, 
    requiredToDisplayFeatureOsrs 
} from './constants'
import { useGetSportFinishPatchImages } from './hooks'
import { createProductArray, getCustomSizingSelectData } from './utils'

export const Substep = ({ state, dispatch, data, stepData, substepData }) => {
    const [products, setProducts] = useState(null)
    const [optionsArray, setOptionsArray] = useState([])
    const [fieldsValidation, setFieldsValidation] = useState({})
    const [selectedCategory, setCategory] = useState('All')
    const [selectedDescription, setDescription] = useState('')
    const [imageArray, setImageArray] = useState([])
    const [borderColor, setBorderColor] = useState()
    const [imageSelected, setImageSelcted] = useState(null)
    const [toggleFields, setToggleFields] = useState(false)
    const [selectedProductObject, setSelectedProductObj] = useState({})

    const [gaState, gaDispatch] = useContext(GAContext)
    const carouselRef = useRef(null);

    const [sportFinishPatchImages] = useGetSportFinishPatchImages()

    const mobile = state.resize < 1025
    const hardCodedDropdownSteps = ["Right Sleeve", "Left Sleeve"]
    const configurableProductOSRs = ["ACTIVITY_PATCHWEB", "SFEMBWEB"]
    const sliderObjInput = [{ 'imageArray': '', 'field': '', 'show': false }]
    const isValidationPassed = Object.values(fieldsValidation).every(field => field.isValid === true)

    const detectTab = (index) => {
        if (index > 3 && !((index + 1) % 6)) {
            carouselRef.current.slickGoTo(index / 3)
        }
        else if (index < 3 && document.getElementsByClassName("slick-prev")[0]) {
            document.getElementsByClassName("slick-prev")[0].click()
        }
    }

    const imgClick = (field, patchValue) => {
        if (imageSelected === patchValue) return
        setBorderColor('image-border')
        setImageSelcted(patchValue)
        chooseSelect(field.featureOsr, patchValue, field)
    }

    //! Temporary solution which should be removed after backend will solve managing
    //!  differentiation issues for patch-option-data and finish-patch-option-data 
    const getIsSportFinishPatches = (options, imagesList) => {
        const firsFoundOptionOsr = options?.find(option => option?.optionOsr)
        const isSportFinishPatchImagesList = imagesList?.some(item => item?.PATCH === firsFoundOptionOsr?.optionOsr)

        return Boolean(isSportFinishPatchImagesList)
    }

    const sliderRenderer = () => {
        const field = sliderObjInput.field
        const subStepSelectedPatch = sliderObjInput.subStepSelectedPatch
        const newOptionsArray = state.choices[substepData.title]?.product?.features?.[0]?.options

        const isSportFinishPatches = getIsSportFinishPatches(newOptionsArray, sportFinishPatchImages)
        const imagesList = isSportFinishPatches ? sportFinishPatchImages : imageArray

        return (sliderObjInput.show && imagesList.length > 0 && (
            <PatchesSlider
                borderColor={borderColor}
                imageArray={imagesList}
                imageSelected={imageSelected}
                newOptionsArray={newOptionsArray}
                selectedDescription={selectedDescription}
                setBorderColor={setBorderColor}
                sliderRef={carouselRef}
                subStepSelectedPatch={subStepSelectedPatch}
                detectTab={detectTab}
                imgClick={imgClick}
                field={field}
            />
        ))
    }

    const CheckCompletedSteps = () => {
        const choicesArray = Object.values(state.choices)
        let newChoiceData = state.choices

        for (let i = 0; i < choicesArray.length; i++) {
            let complete = false
            if (choicesArray[i].product && choicesArray[i].product.productId) {
                complete = true
            }
            if (choicesArray[i].fields && (Object.values(choicesArray[i].fields).length > 0)) {
                if (Object.keys(choicesArray[i].fields).every(field => {
                    if (choicesArray[i].fields[field] && Object.values(choicesArray[i].fields[field]).length > 0) {
                        if (choicesArray[i].fields[field].required) {

                            if (choicesArray[i].fields[field].displayType === DISPLAY_TYPES.INSCRIPT && choicesArray[i].fields[field].chosenValue && isValidationPassed) {
                                return true
                            } else if ((choicesArray[i].fields[field].displayType === DISPLAY_TYPES.SINGLE_SELECT || choicesArray[i].fields[field].displayType === DISPLAY_TYPES.STD_DROP) && choicesArray[i].fields[field].chosenOption && Object.keys(choicesArray[i].fields[field].chosenOption).length > 0) {
                                return true
                            } else {
                                return !!choicesArray[i].fields[field].chosenValue
                            }
                        }

                        return true
                    }
                    const allSubStepSelectData = state.choices[choicesArray[i].title].product.features
                    const currentSubStepFields = state.choices[choicesArray[i].title]
                    const requiredFieldsFeatureOsrs = allSubStepSelectData?.reduce((acc, curr, index) => {
                        const isFirstField = index === 0
                        const isInsertField = curr.featureOsr.indexOf('INSERT') === 0
                        const previousFieldChosenValue = allSubStepSelectData[index - 1]?.chosenValue
                        const currentFieldChosenValue = allSubStepSelectData[index]?.chosenValue
                        const isFieldRequiredToDisplay = requiredToDisplayFeatureOsrs.includes(curr.featureOsr)
                        const isCurrentEmptyAndPreviousSelected = !currentFieldChosenValue && previousFieldChosenValue
                        const IsPreviousNoThanksSelected = previousFieldChosenValue && previousFieldChosenValue === NO_THANKS_OPTION.displayName
                        const isInscriptDisplayType = curr.displayType === DISPLAY_TYPES.INSCRIPT
                        const isFieldForcedRequired = !isInscriptDisplayType 
                                                        && isInsertField 
                                                        && (
                                                            isFirstField 
                                                            || isCurrentEmptyAndPreviousSelected && !IsPreviousNoThanksSelected 
                                                            || IsPreviousNoThanksSelected && isFieldRequiredToDisplay
                                                        )

                        if (curr.required || !curr.required && isFieldForcedRequired) {
                            acc.push(curr.featureOsr)
                        }

                        return acc
                    }, [])
                    
                    const isAllRequiredFieldsFilled = requiredFieldsFeatureOsrs?.every(
                        featureOsr => currentSubStepFields.fields[featureOsr].chosenValue
                    )

                    return !!isAllRequiredFieldsFilled
                })) {
                    complete = true
                } else {
                    complete = false
                }
            }
            
            newChoiceData[choicesArray[i].title].completed = !!(complete && isValidationPassed);
        }
        setChoices(dispatch, newChoiceData)
    }

    const chooseProduct = product => {
        const newChoiceState = state.choices
        newChoiceState[substepData.title].fields = {}
        newChoiceState[substepData.title].product = product
        if (product && product.features && product.features.length > 0) {
            for (let k = 0; k < product.features.length; k++) {
                newChoiceState[substepData.title].fields[product.features[k].featureOsr] = ""
            }
        }
        setChoices(dispatch, newChoiceState)
        CheckCompletedSteps()
        setImageSelcted(null)
        setCategory('All')
        setDescription('')
    }
    
    const chooseSelect = (field, value, fieldData) => {
        let productCondition = false

        if (configurableProductOSRs.includes(selectedProductObject.productOsr)) {
            const relatedSubSteps = Object.keys(state.choices).filter((key) => state.choices[key].step === state.step);
            const relatedSubStepsChosenOsr = [
                ...relatedSubSteps.map((key) => ({
                    chosenOsr: state.choices[key].fields[field]?.chosenOsr,
                    productOsr: state.choices[key].product.productOsr
                })
                )]
            productCondition = relatedSubStepsChosenOsr.some(({ chosenOsr, productOsr }) =>
                chosenOsr === value && productOsr === selectedProductObject.productOsr)
        }

        if (productCondition) {
            const popupPayload = {
                popupWidth: '910px',
                info: (
                    <Popup
                        firstOptionText={LABELS.CHOOSE_ANOTHER}
                        secondOptionText={LABELS.KEEP_IT_AS_IS}
                        handleFirstOptionClick={() => keepAsIsHandler(selectedProductObject)}
                        handleSecondOptionClick={() => navigateToStep(stepData.title, substepData.title)}
                        message={MESSAGES.JACKET_DECORATION_ALREADY_SELECTED}
                        title={TITLES.REPETITIVE_SPOT}
                        label={LABELS.CHOOSE_FROM_OPTIONS}
                        imageSrc={products[0]?.imageUrl}
                        mobile={mobile}

                    />
                )
            }

            setPopup(dispatch, popupPayload)
        }

        sessionStorage.setItem("optionSelected", true)
        if (value !== "") {
            const newChoiceState = state.choices

            const selectedFieldDataProduct = newChoiceState[substepData.title].product
            const selectedFieldDataFields = newChoiceState[substepData.title].fields

            selectedFieldDataFields[field] = fieldData
            selectedFieldDataFields[field]["chosenOsr"] = value 

            if (value === NO_THANKS_OPTION.displayName) {
                selectedFieldDataFields[field]["chosenValue"] = value

                const fieldsKeys = Object.keys(selectedFieldDataFields)
                const currentFieldIndex = fieldsKeys.indexOf(field)

                const generatedOptionsEntries = Object.entries(selectedFieldDataFields).map(([featureOsr, data], index) => {
                    if (index <= currentFieldIndex) {
                        if (data.chosenOsr && !data.chosenValue) data['chosenValue'] = data.chosenOsr

                        return [featureOsr, data]
                    }

                    return [featureOsr, '']
                })

                const generatedOptionsObject = Object.fromEntries(generatedOptionsEntries)

                selectedFieldDataProduct.features?.forEach((feature, index) => {

                    if (generatedOptionsObject[feature.featureOsr]) {
                        if (generatedOptionsObject[feature.featureOsr]?.chosenValue === NO_THANKS_OPTION.displayName) {
                            generatedOptionsObject[feature.featureOsr]['chosenOption'] = NO_THANKS_OPTION
                        }

                        return
                    }

                    const payload = { ...feature, chosenValue: undefined, chosenOption: NO_THANKS_OPTION }

                    selectedFieldDataProduct.features[index] = payload
                })

                newChoiceState[substepData.title].fields = generatedOptionsObject
            }

            if (selectedFieldDataProduct.originalImage === undefined) {
                selectedFieldDataProduct.originalImage = selectedFieldDataProduct.imageUrl
            }

            if (value !== NO_THANKS_OPTION.displayName) {
                for (let i = 0; i < selectedFieldDataFields[field].options.length; i++) {
                    if (selectedFieldDataFields[field].options[i].optionOsr === value) {
                        if (selectedFieldDataProduct.features?.length > 1) selectedFieldDataFields[field]["chosenValue"] = value

                        selectedFieldDataFields[field]["chosenOption"] = selectedFieldDataFields[field].options[i]

                        if (specialCaseSelectionList.indexOf(fieldData.featureOsr) > -1) {
                            selectedFieldDataProduct.imageUrl = newChoiceState[substepData.title].fields[field].options[i].imageUrl
                        }
                    } else if (specialCaseSelectionList.indexOf(fieldData.featureOsr) > -1 && value === "") {
                        selectedFieldDataProduct.imageUrl = selectedFieldDataProduct.originalImage
                    }
                }
            }
            setChoices(dispatch, newChoiceState)
            if (!fieldData.required || (fieldData.required && value)) {
                CheckCompletedSteps()
            }
        }
    }

    const fetchImageByCategory = (value) => {
        setCategory(value)
    }

    const fetchImageByTextinput = (value) => {
        setDescription(value)
    }

    useEffect(() => {
        let res = [];
        let res1 = [];
        let res2 = [];
        let res3 = [];
        let resBySubcategory = [];

        if (('JacketPatchConfiguratorOptionData' in AppData.patchdata) && (AppData?.patchdata?.JacketPatchConfiguratorOptionData?.length !== 0)) {
            if (selectedCategory === 'All' && selectedDescription === '') {
                res = AppData.patchdata?.JacketPatchConfiguratorOptionData
            }
            else if (selectedCategory === 'All') {
                res = AppData.patchdata?.JacketPatchConfiguratorOptionData.filter(inp => inp.DESCRIPTION.toLowerCase().includes(selectedDescription.toLowerCase()))
                res1 = AppData.patchdata?.JacketPatchConfiguratorOptionData.filter(inp => inp.DESCRIPTION__1.toLowerCase().includes(selectedDescription.toLowerCase()))
                res2 = AppData.patchdata?.JacketPatchConfiguratorOptionData.filter(inp => inp.DESCRIPTION__2.toLowerCase().includes(selectedDescription.toLowerCase()))
                res3 = AppData.patchdata?.JacketPatchConfiguratorOptionData.filter(inp => inp.DESCRIPTION__3.toLowerCase().includes(selectedDescription.toLowerCase()))
                if (selectedDescription !== '') {
                    resBySubcategory = AppData.patchdata?.JacketPatchConfiguratorOptionData.filter(inp => inp.SUBCATEGORY.toLowerCase().includes(selectedDescription.toLowerCase()))
                }
            }
            else {
                res = AppData.patchdata?.JacketPatchConfiguratorOptionData.filter(element => ((element.CATEGORY === selectedCategory) && (element.DESCRIPTION.toLowerCase().includes(selectedDescription.toLowerCase()))))
                res1 = AppData.patchdata?.JacketPatchConfiguratorOptionData.filter(element => ((element.CATEGORY === selectedCategory) && (element.DESCRIPTION__1.toLowerCase().includes(selectedDescription.toLowerCase()))))
                res2 = AppData.patchdata?.JacketPatchConfiguratorOptionData.filter(element => ((element.CATEGORY === selectedCategory) && (element.DESCRIPTION__2.toLowerCase().includes(selectedDescription.toLowerCase()))))
                res3 = AppData.patchdata?.JacketPatchConfiguratorOptionData.filter(element => ((element.CATEGORY === selectedCategory) && (element.DESCRIPTION__3.toLowerCase().includes(selectedDescription.toLowerCase()))))
            }
        }
        res = [...res, ...res1, ...res2, ...res3, ...resBySubcategory]
        res = [...new Set(res)]
        setImageArray(res)
    }, [selectedDescription, selectedCategory])

    const handleTextValidation = ({ field, isValid, errorMsg }) => {
        setFieldsValidation(prevState => ({
            ...prevState,
            [field]: { isValid, errorMsg }
        }))
    }

    const handleTextInput = (field, value, fieldData) => {
        const firstCharSpaceReg = new RegExp(/^\S.*$/g)
        const firstCharSpace = firstCharSpaceReg.test(value)
        let inputValue = value
        if (!firstCharSpace) {
            inputValue = value.trim()
        }
        const newChoiceState = state.choices
        newChoiceState[substepData.title].fields[field] = fieldData
        newChoiceState[substepData.title].fields[field]["chosenOsr"] = fieldData?.options[0]?.optionOsr
        newChoiceState[substepData.title].fields[field]["chosenOption"] = fieldData?.options[0]
        newChoiceState[substepData.title].fields[field]["chosenValue"] = inputValue
        if (newChoiceState[substepData.title].product.originalImage === undefined) {
            newChoiceState[substepData.title].product.originalImage = newChoiceState[substepData.title].product.imageUrl
        }
        setChoices(dispatch, newChoiceState)
        if (fieldData?.options[0]?.input?.regex && inputValue.length > 0) {
            const regexTest = new RegExp(fieldData.options[0].input.regex)
            const regexResult = regexTest.test(value)
            if (!regexResult) {
                handleTextValidation({
                    field: fieldData.featureOsr,
                    isValid: true
                })
            } else {
                const errorMsg = `Invalid characters entered: ${value}`
                handleTextValidation({
                    field: fieldData.featureOsr,
                    isValid: false,
                    errorMsg
                })
            }

        }
        if (inputValue === "") {
            handleTextValidation({
                field: fieldData.featureOsr,
                isValid: true
            })
        }
        if (!fieldData.required || (fieldData.required && inputValue)) {
            CheckCompletedSteps()
        }
    }

    const getSelectValue = field => {
        return (state.choices[substepData.title].fields[field] && state.choices[substepData.title].fields[field].chosenOsr)
            ? state.choices[substepData.title].fields[field].chosenOsr
            : state.choices[substepData.title].fields[field]
    }

    const checkError = (field) => {
        if (!fieldsValidation[field]) {
            return
        } else {
            return fieldsValidation[field].errorMsg
        }
    }

    let finalImgIndex = useCallback((inpPatchName) => {
        let finalImgArray = []
        let patchArray = ['', '__1', '__2', '__3']
        imageArray.forEach((obj, index) => {
            patchArray.forEach((p, pIndex) => {
                if (obj['PATCH' + p]) {
                    finalImgArray.push({ objectId: index, patchId: pIndex, patchName: obj['PATCH' + p] })
                }
            })
        })
        if (finalImgArray && (finalImgArray.length !== 0)) {
            const index = finalImgArray.findIndex((object) => {
                return (object.patchName === inpPatchName)
            })
            return index
        }
    }, [imageArray])

    useEffect(() => {
        CheckCompletedSteps();
    }, [fieldsValidation])

    useEffect(() => {
        const patchName = state.choices[substepData.title].fields[Object.keys(state.choices[substepData.title].fields)[0]]?.chosenOsr
        if (imageArray && (imageArray.length !== 0)) {
            let finalIndex = finalImgIndex(patchName)
            carouselRef && carouselRef.current && carouselRef.current.slickGoTo(Math.floor(1 + ((finalIndex - 7) / 2)));
        }


    }, [imageArray, state.choices, substepData.title, finalImgIndex])

    const getInputValue = (field) => {
        let value = (state.choices[substepData.title].fields[field] && state.choices[substepData.title].fields[field].chosenValue)
            ? state.choices[substepData.title].fields[field].chosenValue
            : ""
        return value
    }

    const ProductInformation = () => {
        let url = null
        if (state.choices[state.substep].product.faqUrl) {
            let faq = state.choices[state.substep].product.faqUrl.split(" ").join("")
            url = window.location.origin + faq
        }
        if (state.choices[state.substep].product.longDescription) {
            const popupPayload = {
                title: <H2>{`${state.choices[state.substep].product.displayName} Product Information`}</H2>,
                info: <Fragment>
                    {state.choices[state.substep].product.longDescription && (
                        <Fragment>
                            <H5>{LABELS.PRODUCT_DESCRIPTION}</H5>
                            <P margin="10px 0 0 0">
                                {state.choices[state.substep].product.longDescription.replace(/<([^>]{1,1024}?)>/gi, "")}
                            </P>
                        </Fragment>
                    )}
                    {state.choices[state.substep].product.shippingMessage && (
                        <Fragment>
                            <H5 margin="20px 0 0 0">{LABELS.SHIPPING_DETAILS}</H5>
                            <P margin="10px 0 0 0">
                                {state.choices[state.substep].product.shippingMessage.replace(/<([^>]{1,1024}?)>/gi, "")}
                            </P>
                        </Fragment>
                    )}
                    {state.choices[state.substep].product.specification && (
                        <Fragment>
                            <H5 margin="20px 0 0 0">{LABELS.SPECIFICATIONS}</H5>
                            <P className="specifications" margin="10px 0 0 0" dangerouslySetInnerHTML={{ __html: state.choices[state.substep]?.product?.specification }} />
                        </Fragment>
                    )}
                    {url && (
                        <P margin="20px 0 0 0" decoration="underline" color={Blue} cursor="pointer">
                            <a href={url} target="_blank" rel="noopener noreferrer">{LABELS.VISIT_THE_FAQS}</a>
                        </P>)}
                </Fragment>
            }

            setPopup(dispatch, popupPayload)
        }
    }

    const faq = () => {
        let host
        if (window.location.hostname === 'dev1cms.jostens.com' || window.location.hostname === 'localhost') {
            host = 'devwww.jostens.com'
        } else if (window.location.hostname === 'uatcms.jostens.com') {
            host = 'demowww.jostens.com'
        } else if (window.location.hostname === 'authcms.jostens.com') {
            host = 'www.jostens.com'
        } else {
            host = window.location.hostname
        }
        window.open('https://' + host + '/help/products/other-products/letter-jacket-faq', '_blank');
    }

    useEffect(() => {
        let productArray = []
        if (substepData.products && (substepData.products.length > 0)) {
            productArray = createProductArray(substepData.products, data.products)
        } else if (substepData.locations && (substepData.locations.length > 0)) {
            let locations = data.locationFeatures[substepData.locations[0]]
            productArray = createProductArray(locations, data.products)
        }
        setProducts(productArray)
        if (productArray.length > 0) {
            let optionsArr = [...productArray];
            optionsArr.map((option) => {
                option.adjustmentPrice = option.productPriceDescription?.price ? option.productPriceDescription.price : ""
                return true
            })
            const sortedOptions = sortByOrder({ options: optionsArr, key: 'displayName' })
            sortedOptions.push(NO_THANKS_OPTION)
            setOptionsArray(sortedOptions);
        }
        if (!gaState.enterSubstep.includes(state.substep)) {
            const currentEnterSubsteps = gaState.enterSubstep
            currentEnterSubsteps.push(state.substep)
            gaDispatch({ type: 'SET_ENTER_SUBSTEP', payload: currentEnterSubsteps })
        }
    }, [substepData, data, setProducts, state, gaDispatch, gaState.enterSubstep])

    const navigateToStep = (step, substep) => {
        setPopup(dispatch, null)
        setStep(dispatch, step)
        setSubStep(dispatch, substep)
    }

    const keepAsIsHandler = (productObj) => {
        setPopup(dispatch, null)
        chooseProduct(productObj);
    }

    const clearChoices = () => {
        const clearedFeatures = state.choices[substepData.title].product?.features?.map(feature => ({
            ...feature,
            chosenOsr: undefined,
            chosenValue: undefined,
            chosenOption: undefined
        }))
        const choicesPayload = {
            ...state.choices,
            [substepData.title]: {
                ...state.choices[substepData.title],
                product: {
                    ...state.choices[substepData.title].product,
                    features: clearedFeatures
                }
            }
        }
        setChoices(dispatch, choicesPayload)
    }

    const chooseDropdownValue = (value) => {
        if (value !== "") {

            let productObj = optionsArray.find(product => product.displayName?.trim() === value.split(" [")[0]?.trim())

            if (productObj) {
                productObj.displayName = productObj.displayName.trim()
                setSelectedProductObj(productObj)
            }

            let showRepetitivePopup = false
            let emptySteps = []
            const relatedSubSteps = Object.keys(state.choices).filter((key) => state.choices[key].step === state.step);

            if (hardCodedDropdownSteps.includes(state.step)) {
                const relatedSubStepsProductOsr = [...relatedSubSteps.map((key) => ({ productOsr: state.choices[key]?.product?.productOsr, displayName: state.choices[key]?.product?.displayName }))]
                showRepetitivePopup = relatedSubStepsProductOsr.some(({ productOsr, displayName }) => productObj.productOsr === productOsr && productObj.displayName === displayName && productObj.displayName !== "No Thanks")
            }
            if (hardCodedDropdownSteps.includes(state.step)) {
                let emptyValidationSteps;
                if (state.step === "Right Sleeve") {
                    emptyValidationSteps = RIGHT_SLEAVE_DROPDOWN_VALUES
                } else {
                    emptyValidationSteps = LEFT_SLEAVE_DROPDOWN_VALUES
                }

                const relatedSubStepsDisplayName = [...relatedSubSteps.map((key) => ({ displayName: state.choices[key]?.product?.displayName, title: state.choices[key]?.title }))]
                emptySteps = relatedSubStepsDisplayName.filter(({ displayName, title }) => displayName === "No Thanks" && emptyValidationSteps[state.substep].includes(title))
            }

            // Check the case when decoration exists in both the LS1 and LS2 or RS1 and RS2
            if (!configurableProductOSRs.includes(productObj.productOsr) && showRepetitivePopup) {
                const popupPayload = {
                    popupWidth: '910px',
                    info: (
                        <Popup
                            firstOptionText={LABELS.CHOOSE_ANOTHER}
                            secondOptionText={LABELS.KEEP_IT_AS_IS}
                            handleFirstOptionClick={() => navigateToStep(stepData.title, substepData.title)}
                            handleSecondOptionClick={() => keepAsIsHandler(productObj)}
                            message={MESSAGES.JACKET_DECORATION_ALREADY_SELECTED}
                            title={TITLES.REPETITIVE_SPOT}
                            label={LABELS.CHOOSE_FROM_OPTIONS}
                            imageSrc={products[0]?.imageUrl}
                            mobile={mobile}
                        />
                    )
                }

                setPopup(dispatch, popupPayload)

                // If a sleeve has multiple locations (LS1, LS2) or (RS1, RS2)
                //    a. User says no thanks for LS1, but selects a decoration at LS2, or
                //    b. User says no thanks for RS1, but selects a decoration at RS2.
            } else if (emptySteps.length > 0 && productObj.displayName !== "No Thanks") {
                const subStepName = state.substep.toLowerCase()
                const titleText = emptySteps[0].title.toLowerCase()

                const popupPayload = {
                    popupWidth: '910px',
                    info: (
                        <Popup
                            firstOptionText={LABELS.MOVE_TO_TOP_LOCATION}
                            secondOptionText={LABELS.KEEP_IT_AT_THE_BOTTOM}
                            handleFirstOptionClick={() => navigateToStep(state.step, emptySteps[0].title)}
                            handleSecondOptionClick={() => keepAsIsHandler(productObj)}
                            message={MESSAGES.GENERIC.EMPTY_PLACE_WARN(subStepName, titleText)}
                            title={TITLES.EMPTY_SPOT}
                            label={LABELS.CHOOSE_FROM_OPTIONS}
                            imageSrc={products[0]?.imageUrl}
                            mobile={mobile}
                        />
                    )
                }

                setPopup(dispatch, popupPayload)
            } else {
                chooseProduct(productObj);
            }
            setFieldsValidation({})
            clearChoices()
        }
    }

    const handleSelectWithCustomSizingOption = (featureOsr, field, constantValue) => (data) => {
        const dataValue = constantValue ? constantValue : data.target.value

        return chooseSelect(featureOsr, dataValue, field)
    }

    const handleSetToggleFields = (toggleFields) => () => setToggleFields(toggleFields)

    const renderFields = substepData && ((state.choices[substepData.title]?.product?.productId
        && (state.choices[substepData.title].product.productId !== "no") && !state.choices[substepData.title].required)
        || state.choices[substepData.title].required)
        && state.choices[substepData.title].product.features
        && state.choices[substepData.title].product.features.map((field, key) => {
            let subStepProductOsr = state.choices[substepData.title]?.product?.productOsr
            let locationFilteredArray = state.choices[substepData.title].product.configurations.find((item) => item.featureOsr === "LOCATION")

            if (subStepProductOsr === 'SFEMBWEB') {
                let subStepSelectedPatch = state.choices[substepData.title]?.fields[Object.keys(state.choices[state.substep].fields)[0]].chosenOsr

                sliderObjInput.show = true
                sliderObjInput.field = field
                sliderObjInput.subStepSelectedPatch = subStepSelectedPatch

                return 
            }

            if ((subStepProductOsr === 'ACTIVITY_PATCHWEB')) {
                let subStepSelectedPatch = state.choices[substepData.title]?.fields[Object.keys(state.choices[state.substep].fields)[0]].chosenOsr
                let imageName = state.choices[substepData.title]?.fields[Object.keys(state.choices[state.substep].fields)[0]]?.chosenOption?.displayName
                let categories = []
                if (('JacketPatchConfiguratorOptionData' in AppData.patchdata) && (AppData?.patchdata?.JacketPatchConfiguratorOptionData?.length !== 0)) {
                    categories = ['All', ...new Set(AppData.patchdata.JacketPatchConfiguratorOptionData.map(inp => inp.CATEGORY))]
                }
                sliderObjInput.show = true
                sliderObjInput.field = field
                sliderObjInput.subStepSelectedPatch = subStepSelectedPatch

                const usFlagsOsrs = ['CHCMD_TUSFL', 'CHCMD_TUSFG']
                const isUSFlagSelected = (selectedCategory === 'FLAGS' || usFlagsOsrs.includes(imageSelected))

                return (
                    <>
                        <Block margin="20px 0 0 0" key={`Fields-Select-${key}-${field.displayName}`}>
                            <Flex>
                                <SelectImg
                                    required={field.required}
                                    options={categories}
                                    value={selectedCategory}
                                    onChange={data => fetchImageByCategory(data.target.value)} >
                                </SelectImg>
                                <Input
                                    type="text"
                                    required={field.required}
                                    options={field.options}
                                    maxLength={field.options[0]?.input?.length}
                                    error={checkError(field.featureOsr)}
                                    value={selectedDescription}
                                    placeholder="Search"
                                    onChange={data => fetchImageByTextinput(data.target.value)}
                                />
                                <FontAwesomeIcon icon={faSearch} className="fl-right"></FontAwesomeIcon>
                            </Flex>
                            <Block margin="20px 0 0 0">
                                {isMobile.any() &&
                                    <P size="18px" margin="0 0 0 5px" weight="600" text-align="center" className="capitalize">
                                        {imageName && <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="check-circle" className="svg-inline--fa fa-check-circle fa-w-16 " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"></path></svg>}
                                        {imageName ? ' ' + imageName : null}
                                    </P>}
                                <Grid columns="2.3rem 90%" justifyItems="start" columnGap="0.5rem">
                                    <P size="12px" weight="bold">NOTE: </P>
                                    <P size="11px" margin="0 0 0 10px" className="paraNoted" textTransform="uppercase">{LABELS.PATCH_COLOR}</P>
                                </Grid>
                                { isUSFlagSelected && <Grid columns="2.3rem 90%" justifyItems="start" columnGap="0.5rem">
                                    <P size="12px" weight="bold">NOTE: </P>
                                    <P size="11px" margin="0 0 0 10px" className="paraNoted" textTransform="uppercase">{LABELS.US_FLAG_PATCH}</P>
                                </Grid>}
                            </Block>
                        </Block>
                    </>
                )
            }
            else if (field.displayType && ((field.displayType === DISPLAY_TYPES.SINGLE_SELECT) || (field.displayType === DISPLAY_TYPES.STD_DROP)) && field.options && (field.options.length > 0)) {
                const elementKey = `Fields-Select-${key}-${field.displayName}`
                const isAlterBodyLengthField = field.featureName === "Alter Body Length"

                const { selectOptions, shouldDisplay } = getCustomSizingSelectData(state.choices[substepData.title], field)

                return shouldDisplay && (
                    <SelectWithCustomSizingOption
                        key={field.featureOsr}
                        displayFlag={toggleFields}
                        elementKey={elementKey}
                        handleChooseSelect={handleSelectWithCustomSizingOption(field.featureOsr, field, 'NONE')}
                        handleSelectChange={handleSelectWithCustomSizingOption(field.featureOsr, field)}
                        handleTextElementClick={handleSetToggleFields(!toggleFields)}
                        mode={AppData?.jpidata?.mode}
                        options={selectOptions}
                        required={field.required}
                        shouldDisplayText={isAlterBodyLengthField}
                        title={field.displayName}
                        toggleFields={toggleFields}
                        value={getSelectValue(field.featureOsr)}
                    />
                )
            }
            if (field.displayType && (field.displayType === DISPLAY_TYPES.INSCRIPT)) {
                const adjustmentPriceValue = field.options && field.options.length > 0 && field.options[0]?.adjustmentPrice?.toFixed(2)
                const formatedCurrency = CURRENCY[state.choices[substepData.title].product.currencyCode]
                const formatedAdjastmentPrice = adjustmentPriceValue ? ` [+ ${formatedCurrency}${adjustmentPriceValue}]` : null

                return (
                    <Block margin="20px 0 0 0" key={`Fields-Input-${key}-${field.displayName}`}>
                        <Input 
                            title={field.displayName}
                            legend={field.displayName}
                            type="text"
                            required={field.required}
                            options={field.options}
                            maxLength={field.options[0]?.input?.length}
                            error={checkError(field.featureOsr)}
                            value={getInputValue(field.featureOsr)}
                            onChange={data => handleTextInput(field.featureOsr, data.target.value, field)}
                            displayEmborideryText={locationFilteredArray.optionValue}
                            formatedAdjastmentPrice={formatedAdjastmentPrice}
                        />
                    </Block>
                )
            }
            return null
        });

    return (
        <Block width="calc(100% - 30px)" margin="0 auto">
            {mobile && <Fragment>
                <P margin="20px 0 0 0" color="gray" hover="gray">{LABELS.BUILD_YOUR_OWN_PACKAGE}</P>
                <Flex margin="10px 0 30px 0" justify="flex-start" align="center">
                    <P size="20px" weight="bold" color="#095AC3" hover="#095AC3">Step {state.stepnumber + 1} of {state.stepamount + 1}:</P>
                    <P size="20px" weight="bold" margin="0 0 0 10px">{state.step}</P>
                </Flex>
            </Fragment>}
            {(substepData.title)
                && <P margin={!mobile && "30px 0 10px 0"} textTransform="inherit" size="16px" weight="bold" className={substepData?.title ? "showClass paraWidth" : "hiddenClass pClass"}>
                    {substepData.title.toUpperCase()}:
                </P>
            }
            {!isMobile.any() &&
                <P size="18px" margin="0 0 0 5px" weight="600" text-align="center" className="paraWidth patchWidth capitalize">
                    {(state.choices[substepData.title]?.fields?.INSERT01?.chosenOption?.displayName) && <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="check-circle" className="svg-inline--fa fa-check-circle fa-w-16 " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"></path></svg>}
                    {(state.choices[substepData.title]?.fields?.INSERT01?.chosenOption?.displayName) ? ' ' + (state.choices[substepData.title]?.fields?.INSERT01?.chosenOption?.displayName) : null}
                </P>}
            <P size="18px" weight="600" text-align="center" className="capitalize paraWidth priceWidth">
                {substepData.title !== "Size & Material" ?
                    state.choices[substepData.title].product.productPriceDescription.formattedPrice : ""
                }</P>

            {substepData.description && (!substepData.hasOwnProperty("locations"))
                && <Block margin={mobile ? "5px 0 40px 0" : "0 0 30px 0"}>
                    <P color={Gray_600} hover={Gray_600}>
                        {substepData.description}
                    </P>
                    {state.choices[state.substep]?.product?.features && state.choices[state.substep]?.product?.features.length > 0
                        && <Fragment>
                            {state.choices[state.substep].product.features.map((feature, key) =>
                                <Fragment key={`FaqUrl-${key}`}>
                                    {
                                        (feature.featureOsr === "SIZE-APPAREL") ?
                                            <P margin={"5px 0 0 0"} cursor="pointer" color={Blue} hover={"#031D40"} decoration="underline">
                                                <a href={window.location.origin + feature.faqUrl} target="_blank" rel="noopener noreferrer">
                                                    Sizing Help <FontAwesomeIcon icon={faInfoCircle} /></a>
                                            </P> : null
                                    }
                                </Fragment>
                            )}
                        </Fragment>}
                </Block>
            }
            {products && (products.length > 0)
                && <Fragment>
                    {((substepData.required && (products.length > 1)) || !substepData.required) ?
                        (substepData.productViewType === "DROPDOWN") ? // src={products[0]?.imageSet[0]?.variants?.product_lg}
                            <Fragment>
                                <Grid columns={'30% 70%'}>
                                    <Block margin="20px 0 0 0">
                                        <ImageBlock
                                            width="100%"
                                            src={products[0]?.imageUrl}
                                            alt={`${products[0]?.displayName} image`}
                                            ariaLabel={`${products[0]?.displayName} image`}
                                        />
                                    </Block>
                                    <Block
                                        margin="20px 0 0 10px"
                                        key={`Fields-Select-${substepData.title}`}
                                    >
                                        <P 
                                            margin={mobile ? "5px 0 10px 0" : "0 0 10px 0"}
                                            color={Gray_Dark}
                                            hover={Gray_Dark}
                                        >
                                            {substepData.description}
                                        </P>
                                        <Select
                                            options={optionsArray}
                                            value={state?.choices && state.choices[substepData.title]?.product?.displayName + ((state.choices[substepData.title]?.product?.adjustmentPrice) ? ` [+ $${state.choices[substepData.title]?.product?.adjustmentPrice?.toFixed(2)}]` : "")}
                                            onChange={(event) => chooseDropdownValue(event.target.value)}
                                            ariaLabel={`${substepData.title}-product-options`}
                                            legend={`${substepData.title} Options`}
                                        />
                                        {renderFields}
                                    </Block>
                                </Grid>
                                <Block width="auto" margin="20px -15px 0 -15px" className="carousel-styles">
                                    {sliderRenderer()}
                                </Block>
                            </Fragment>
                            :
                            <Fragment>
                                <Grid columns={mobile
                                    ? "calc(50% - 20px) calc(50% - 20px)"
                                    : "calc(25% - 15px) calc(25% - 15px) calc(25% - 15px) calc(25% - 15px)"
                                }
                                    columnGap="20px"
                                    rowGap="20px">
                                    {products.map((product, key) => {
                                        return (
                                            <Product z={key * (-1)} key={`Product-${key}`}
                                                product={product}
                                                dispatch={dispatch}
                                                mobile={mobile}
                                                onClick={data => chooseProduct(data)}
                                                activeId={state && state.choices && state.choices[substepData.title].product.productId} />)

                                    })}
                                    {!substepData.required
                                        && (
                                            <Product
                                                dispatch={dispatch}
                                                mobile={mobile}
                                                z={(products?.length + 1) * (-1)}
                                                noImage={products[0]?.imageUrl}
                                                onClick={data => chooseProduct(data)}
                                                activeId={state && state.choices && state.choices[substepData.title]?.product?.productId}
                                            />
                                        )
                                    }
                                </Grid>
                                {renderFields}
                            </Fragment>
                        : (products?.length === 1) ? <>{renderFields}</> : null
                    }
                </Fragment>
            }
            {((mobile && products && substepData.required && (products.length === 1)) || !mobile)
                && <Flex margin="20px 0 20px 0" justify="flex-start">
                    {state.choices[state.substep].product
                        && state.choices[state.substep].product.displayName
                        && state.choices[state.substep].product.displayName !== "No Thanks"
                        && state.choices[state.substep].product.longDescription
                        && <P onClick={() => ProductInformation()} cursor="pointer" color={Blue} decoration="underline">
                            Product Information <FontAwesomeIcon icon={faInfoCircle} />
                        </P>}
                </Flex>
            }
            <Flex margin="20px 0 20px 0" justify="flex-start">
                <P onClick={() => faq()} cursor="pointer" color={Blue} decoration="underline"> Jacket FAQs</P>
            </Flex>
        </Block>
    )
}